import { render, staticRenderFns } from "./word-item-panel.vue?vue&type=template&id=66bc181d&"
import script from "./word-item-panel.vue?vue&type=script&lang=js&"
export * from "./word-item-panel.vue?vue&type=script&lang=js&"
import style0 from "./word-item-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('66bc181d', component.options)
    } else {
      api.reload('66bc181d', component.options)
    }
    module.hot.accept("./word-item-panel.vue?vue&type=template&id=66bc181d&", function () {
      api.rerender('66bc181d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/word-list/word-item-panel.vue"
export default component.exports